import axios from "axios";

// 创建axios实例
const service = axios.create({
  baseURL: "",
  timeout: 15000, // 请求超时时间
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "X-tenant-Id": import.meta.env.MODE === "official" ? 2 : 1,
  },
});

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code !== "200" && res.code !== "0") {
      showToast({
        message: res.message || res.msg || "请求失败",
        type: "fail",
        duration: 2000,
      });
      return Promise.reject(new Error(res.message || res.msg || "请求失败"));
    } else {
      return res;
    }
  },
  (error) => {
    let message = error.message || "请求失败";

    if (error.response) {
      message = "请求错误";
    }

    showToast({
      message: message,
      type: "fail",
      duration: 2000,
    });

    return Promise.reject(error);
  }
);

export function get(url, params) {
  return service({
    url,
    method: "get",
    params,
  });
}

export function post(url, data) {
  return service({
    url,
    method: "post",
    data,
  });
}

export function put(url, data) {
  return service({
    url,
    method: "put",
    data,
  });
}

export function del(url, params) {
  return service({
    url,
    method: "delete",
    params,
  });
}

export default service;
